module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAAUVJREFUeAHt3CsOwkAUheHe4RESEhy+ogbFUlAYQLMcdgEGxU5AIVpRj0PxKAy9CSScNcxfBbj+/XocYzFGO9f1LMawMIvjLKHr/YrXJjb7aVFs7ViWq+FguBn0e2MzSyhDlrUIstvjeXk293XoWneeYgR/4v7g/d79bQihY6PUJPyz93v3SQj/P6b8mRDfp08IQugQIAIRiNACiNAebAQiEKEFEKE92AhEIEILIEJ7sBGIQIQWQIT2YCMQgQgtgAjtwUYgAhFaABHag41ABCK0ACK0BxuBCERoAURoDzYCEYjQAojQHmwEIhChBRChPdgIRCBCCyBCe7ARiECEFkCE9mAjEIEILYAI7cFGIAIRWuAnoj014eL/mk/18nv34xOC2XvnRwekGON3bIKfIWHtFztV1dKPT/CTA1KS4W+DQ5jk+eEDj89QYuO4dU0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/office-logo_1x.png
// module id = 2314
// module chunks = 0